import { useTranslation } from 'react-i18next'
import { Card, CardBody } from '@structural-climbing/ui'

interface Props {
  description: string | null
  prizes: string | null
}

/**
 * The gym's own copy about a competition. Shared by the pre-join screen and the
 * joined-but-not-started screen, which show the same thing under a different
 * call to action.
 */
export function CompetitionAbout({ description, prizes }: Props) {
  const { t } = useTranslation()

  return (
    <>
      {description && (
        <Card className="shadow-sm">
          <CardBody className="gap-2">
            <h2 className="font-bold">{t('competitions.aboutTitle')}</h2>
            <p className="whitespace-pre-line text-sm text-foreground/70">{description}</p>
          </CardBody>
        </Card>
      )}

      {prizes && (
        <Card className="shadow-sm">
          <CardBody className="gap-2">
            <h2 className="font-bold">{t('competitions.prizesTitle')}</h2>
            <p className="whitespace-pre-line text-sm text-foreground/70">{prizes}</p>
          </CardBody>
        </Card>
      )}
    </>
  )
}
